// ----------------------------------------------------------------------
// <copyright file="Izenda.Option.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
* Option component of multi selectbox
*/
!function () {
  var React = require('react');
  var classnames = require('classnames');

  var Option = React.createClass({
    propTypes: {
      children: React.PropTypes.node,
      className: React.PropTypes.string,
      onSelect: React.PropTypes.func,
      option: React.PropTypes.object.isRequired
    },

    blockEvent: function(event) {
      event.preventDefault();
      event.stopPropagation();
    },

    handleMouseDown: function(event) {
      this.blockEvent(event);
      this.props.onSelect(this.props.option, event);
    },

    render : function() {
      var option = this.props;

      return option.disabled
      ? (
        <div
          className={option.className}
          onMouseDown={this.blockEvent}
          onClick={this.blockEvent}
        >
          {this.props.children}
        </div>
      ) : (
        <div
          className={option.className}
          style={option.style}
          title={option.title}
          onMouseDown={this.handleMouseDown}
        >
          {this.props.children}
        </div>
      );
    }

  });

  module.exports = Option;
}();



// WEBPACK FOOTER //
// ./ui/share/components/controls/multiSelectBox/Izenda.Option.jsx